import classNames from "classnames";
import React, { ReactElement } from "react";
import styles from "./MainParagraphText.module.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function MainParagraphText({
  children,
  className,
}: Props): ReactElement {
  return (
    <div className={classNames(styles.paragraph, className)}>{children}</div>
  );
}
